 <template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div id="app">
      <div class="content-wrapper">
        <div class="container-fluid">
          <img class="logo" src="../assets/img/logo-comprodonto.png" alt>
          <div class="box_general padding_bottom">


            <div class="row">
              <div class="col-md-12">
                <div v-if="erroLogin" class="alert alert-danger alert-dismissible" role="alert">
                  <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    @click="erroLogin = !erroLogin"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <strong>{{tituloErro}}!</strong>
                  <span>{{(erroMensagem) ? erroMensagem : 'Erro inesperado, tente novamente mais tarde!'}}</span>
                </div>
              </div>
              <div class="col-md-12">

                <div class="form-group">
                  <label>Login</label>
                  <input type="text" class="form-control" placeholder="Login" v-model="user.email">
                </div>
              </div>
            </div>
            <!-- /row-->
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">

                  <label>Senha</label>
                  <input
                    type="password"
                    class="form-control"
                    placeholder="Senha"
                    v-model="user.password"
                    @keyup.enter="login"
                  >
                </div>
              </div>
              <div class="col-md-12">
                <button class="btn_1 medium " type="button" @click="login()">Logar</button>
              </div>
            </div>
            <!-- /row-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ajax, tratamento_requisicao, alerta } from "../utils/util";
import funcoesGerais from "../assets/js/funcoes.js";
const jwt_decode = require('jwt-decode');
export default {
  mixins: [funcoesGerais],
  data: function() {
    return {
      user: {
        email: "",
        password: ""
      },
      isLoading: false,
      erroLogin: false,
      erroMensagem: "Tente novamente"
    };
  },
  methods: {
    login() {
      let self = this;

      if (self.user.email && self.user.password) {
        self.isLoading = true;
        ajax("post", "/autenticar/admin", {
          login: self.user.email,
          senha: self.user.password
        })
          .then(response => {
            self.isLoading = false;

            localStorage.setItem("token_adm_comprodonto", JSON.stringify(response))
            localStorage.setItem("adm_comprodonto_role", response.role)
            var decoded = jwt_decode(response.token);
            let tipo = response.role;
            if (tipo == 3) {
              self.$router.replace(self.$route.query.redirect || "/adm/dashboard");
            } else if(tipo == 2) {
              self.$router.replace(self.$route.query.redirect || "/uniodonto/dashboard");
            }else if(tipo == 4) {
              self.$router.replace(self.$route.query.redirect || "/corretor/dashboard");
            }

          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error, this);
          });
      } else {
        alerta('danger','Atenção',"Preencha os campos");
      }
      return false;
    }
  }
};
</script>
<style scoped>
.box_general {
  display: table;
  margin: 5% auto;
  width: 30%;
}
.content-wrapper {
  margin-left: 0px;
  background-color: #fff;
}
#exampleAccordion {
  display: none;
}
.logo {
  display: table;
  width: 250px;
  margin: 0 auto;
}

body {
  background-color: #f8f8f8 !important;
}
</style>
